/* eslint-disable react/react-in-jsx-scope */

import { SVGProps } from 'react';

const MyPageIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' width='38' height='38' viewBox='0 0 38 38' fill='none'>
      <g>
        <path d='M19 17.4167C20.2526 17.4167 21.4771 17.0452 22.5186 16.3493C23.5601 15.6534 24.3719 14.6643 24.8512 13.507C25.3306 12.3497 25.456 11.0763 25.2116 9.84776C24.9673 8.61922 24.3641 7.49073 23.4783 6.60499C22.5926 5.71926 21.4641 5.11607 20.2356 4.8717C19.007 4.62732 17.7336 4.75274 16.5763 5.2321C15.4191 5.71145 14.4299 6.52321 13.734 7.56472C13.0381 8.60624 12.6667 9.83072 12.6667 11.0833C12.6667 12.763 13.3339 14.3739 14.5217 15.5617C15.7094 16.7494 17.3203 17.4167 19 17.4167Z' />
        <path d='M28.5 33.25C28.9199 33.25 29.3227 33.0832 29.6196 32.7863C29.9165 32.4894 30.0833 32.0866 30.0833 31.6667C30.0833 28.7272 28.9156 25.9081 26.8371 23.8296C24.7586 21.7511 21.9395 20.5834 19 20.5834C16.0605 20.5834 13.2414 21.7511 11.1629 23.8296C9.08437 25.9081 7.91667 28.7272 7.91667 31.6667C7.91667 32.0866 8.08348 32.4894 8.38041 32.7863C8.67735 33.0832 9.08007 33.25 9.5 33.25H28.5Z' />
      </g>
      <defs>
        <clipPath id='clip0_2452_338'>
          <rect width='38' height='38' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
export default MyPageIcon;
